import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH_PEDIDO = 'api/pedido'
const URL_PATH_ITEM_PEDIDO = 'api/item-pedido'

class PedidoApiClient {
	async buscarItens(filtro, paginacao, idPedido) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH_PEDIDO}/${idPedido}/itens`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}

	async buscarItensDisponiveis(filtro, paginacao, idPedido) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH_PEDIDO}/${idPedido}/itens/disponiveis`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}
	async salvarItemDisponivelQuantidade(salvarItemDisponivelQuantidadePedidoInput) {
		return await axios.post(
			`${URL_PATH_PEDIDO}/${salvarItemDisponivelQuantidadePedidoInput.idPedido}/itens`,
			salvarItemDisponivelQuantidadePedidoInput,
		)
	}
	async salvarItemQuantidade(salvarItemQuantidadePedidoInput) {
		return await axios.put(
			`${URL_PATH_ITEM_PEDIDO}/${salvarItemQuantidadePedidoInput.idItemPedido}/quantidade-solicitada`,
			salvarItemQuantidadePedidoInput,
		)
	}
	async deletarItem(deletarItemPedidoInput) {
		return await axios.delete(`${URL_PATH_ITEM_PEDIDO}/${deletarItemPedidoInput.idItemPedido}`)
	}
	async buscarElementosSubelementosItem(idItemPedido) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH_ITEM_PEDIDO}/elemento-subelementos`,
			filters: {
				idItemPedido,
			},
		}).build()

		return await axios.get(url)
	}
	async alterarElementoSubelementoItem(idItemPedido, body) {
		return await axios.put(`${URL_PATH_ITEM_PEDIDO}/${idItemPedido}/elemento-subelemento`, body)
	}
}

export default new PedidoApiClient()
